module.exports = __webpack_public_path__ + "static/avatar-female-10b124adcddc2ff8e672b662ac59a9f5.png";